import { useState } from 'react';
import { useSessionMutation, mutationErrorMsg } from '../MsalAccessProvider';

import { useParams, Link, useNavigate } from 'react-router-dom';

import Timestamp from 'react-timestamp';

const Survey = ({surveys, completeTimes, completeSurvey}) => {
  const { sectionId } = useParams();
  const navigate = useNavigate();

  const [ responses, setResponses ] = useState({effective: "", ineffective: "", other: ""});
  const mutationSubmit = useSessionMutation('/cms/submitSurvey');

  // no surveys bailout
  if (!surveys || surveys.length === 0) {
    return (<></>);
  }

  // this survey
  const survey = surveys.find(row => row.id.toString() === sectionId);

  // guard against non-existant
  if (!survey) {
    return (
      <div className="flex flex-row justify-center mt-12">
        <div className="flex flex-col space-y-4 items-center">
          <div>Survey Not Found</div>
          <Link
            to=".."
            className="rounded px-4 py-1 my-auto ml-3 border border-white hover:bg-utrgv-orange">
            Back
          </Link>
        </div>
      </div>
    );
  }

  const submit = () => {
    if (Object.keys(responses).every(key => responses[key].trim() === "")) {
      // nada, discard
      navigate('..');
      return;
    }

    mutationSubmit.mutateAsync({sectionId: sectionId, ...responses}, {
      onSuccess: (response, payload, context) => {
        // all responses are accepted, so good to go
        // update complete time locally and navigate back
        completeSurvey(survey.id);
        navigate('..');
      }
    });
  };

  const updateField = (key, value) => {
    setResponses(response => ({...response, [key]: value}));
  }

  return (
    <>
      <div className="flex flex-col mt-6 mx-8 space-y-6 md:tracking-wide">

        <div className="flex flex-col space-y-4 p-3 rounded bg-cod-gray-mid">

          <div className="my-auto border-b px-2">
            <div className="text-2xl">{survey.subject} {survey.number} {survey.section}</div>
            <div className="text-xl mb-2">{survey.first_name} {survey.last_name}</div>
          </div>

          {// guard against complete, closed
          completeTimes[survey.id] != null
          ?
          <>
            <div>
              Survey Completed <Timestamp date={completeTimes[survey.id]}/>
            </div>

            <div className="flex flex-row justify-center">
            <Link
              to=".."
              className="rounded px-4 py-1 my-auto ml-3 border border-white hover:bg-utrgv-orange">
              Back
            </Link>
            </div>
          </>
          :
          new Date() > new Date(survey.closes)
          ?
          <>
            <div>
              Survey Closed <Timestamp date={survey.closes}/>
            </div>

            <div className="flex flex-row justify-center">
            <Link
              to=".."
              className="rounded px-4 py-1 my-auto ml-3 border border-white hover:bg-utrgv-orange">
              Back
            </Link>
            </div>
          </>
          :
          mutationErrorMsg(mutationSubmit, '')
          ?
          <>
            <div>
              {mutationErrorMsg(mutationSubmit, 'Unable to submit responses! Please report this error')}
            </div>

            <div className="flex flex-row justify-center">
            <Link
              to=".."
              className="rounded px-4 py-1 my-auto ml-3 border border-white hover:bg-utrgv-orange">
              Back
            </Link>
            </div>
          </>
          :
          <>
            <div>
              Thank you for taking this survey! It is helpful for our instructors to get feedback from
              all students here at the midpoint of the semester. 
            </div>

            <div>
              This survey is ANONYMOUS to the instructor. They will be provided with:
              <ul>
                <li className="mx-4">An alphabetical list of students that completed the survey, to give class credit</li>
                <li className="mx-4">The feedback without identifiers in random order</li>
              </ul>
            </div>

            <div>
              If less than 10 students complete the survey, the feedback will be discarded (credit will still be given).
            </div>

            <div>
              <em>Caveat emptor</em>, Dr. Tomai manages the CS portal and thus has access to the
              un-anonymized data. Critical feedback is fine, but in the unlikely case of personal
              attacks or inappropriate comments, I will look up who is responsible and take action.
            </div>

            <div className="p-3 bg-cod-gray">
            <>
              <div>What parts of this class (materials, activities, instructional methods) have 
                been <strong>most effective</strong> in helping you learn? Please be specific and talk about why.</div>
              <textarea
                className='appearance-none w-full rounded mt-1 p-3 bg-cod-gray-light focus:outline-none' rows="6"
                onChange={e => updateField('effective', e.target.value)}
                value={responses.effective}/>
            </>
          </div>
          <div className="p-3 bg-cod-gray">
            <>
              <div>What parts of this class (materials, activities, instructional methods) have
                been <strong>ineffective</strong> or <strong>made it more difficult</strong> for you to learn? Please be specific and talk about why.</div>
                <textarea 
                  className='appearance-none w-full rounded mt-1 p-3 bg-cod-gray-light focus:outline-none' rows="6"
                  onChange={e => updateField('ineffective', e.target.value)}
                  value={responses.ineffective}/>
            </>
          </div>
          <div className="p-3 bg-cod-gray">
            <>
              <div>Other comments</div>
              <textarea
                className='appearance-none w-full rounded mt-1 p-3 bg-cod-gray-light focus:outline-none' rows="6"
                onChange={e => updateField('other', e.target.value)}
                value={responses.other}/>
            </>
          </div>

          <div className="flex flex-row justify-center">
            <button 
              className="rounded px-4 py-1 my-auto ml-3 border border-white hover:bg-utrgv-blue"
              onClick={submit}>
              Submit
            </button>
            <Link
              to=".."
              className="rounded px-4 py-1 my-auto ml-3 border border-white hover:bg-utrgv-orange">
              Discard
            </Link>
          </div>
          </>
        }
        </div>

      </div>
    </>);
  };

export default Survey;
